var _defs, _path, _circle, _circle2, _circle3, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCc = function SvgCc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0-360l69.42 215.845 212.04-80.3L155.987-35.604l194.986 115.71-225.88 19.65 31.104 224.592L0 160l-156.198 164.35 31.105-224.592-225.88-19.65 194.985-115.71-125.47-188.854 212.037 80.3z",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-210L54.86-75.508l144.862 10.614L88.765 28.842l34.67 141.052L0 93.334l-123.435 76.56 34.67-141.052-110.957-93.736L-54.86-75.508z",
    id: "b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "green",
    d: "M0 0h640v480H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 240,
    r: 66.667,
    fill: "#ffe000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.787,
    cy: 240,
    r: 54.857,
    fill: "green"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.841,
    cy: 173.333,
    r: 69.841,
    fill: "#ffe000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.022 225.994h17.44s.787-1.6-.176-2.398c-.963-.8-4.713-.975-3.7-3.803 2.083-5.813 2.374-4.02 3.682-17.827 1.308-13.806 1.937-35.46 1.937-35.46h-2.52s.486 6.734-.967 15.502c-1.454 8.77-1.89 9.543-3.488 16.277-1.6 6.733-1.84 7.314-3.294 11.238-1.453 3.924-1.6 4.118-3.876 7.75-2.276 3.634-1.453 2.277-2.712 4.457-.63 1.09-1.405.8-1.83 1.593-.423.793-.496 2.67-.496 2.67z",
    fill: "#802000",
    stroke: "#7b3100",
    strokeWidth: 1.481
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.33 122.45c.145 2.71-.127 6.295-1.25 9.213-1.138 3.252-2.376 6.494-2.315 9.86-1.81.617-3.674-3.915-5.416-1.25 1.308 3.685 4.33 6.6 6.403 9.92.35 1.03 3.33 3.716 1.605 4.34-4.353-1.49-5.407-7.003-8.107-10.352-3.134-5.634-8.98-9.617-15.49-9.892-2.447.064-10.4-.607-8.33 3.582 3.047 2.072 6.802 3.423 9.81 5.748 2.243.21 6.306 3.952 6.07 5.367-3.944-1.597-5.79-3.512-10.037-5.19-5.757-2.225-13.72-.887-16.905 4.825-.594 1.488-1.47 5.824.397 6.238 2.183-3.41 5.306-7.22 9.933-6.197 3.635.285-4.055 6.772-1.114 5.466.932-.413 3.085-1.826 4.578-1.974 1.493-.147 2.327.97 3.46 1.125 2.266.31 2.89 1.26 2.68 1.812-.248.65-.968.094-3.27.825-1.153.365-1.754 1.377-3.098 1.84-1.343.464-4.138.496-5.182.086-3.654-1.586-9.644-1.31-10.783 3.268-.002 2.014-1.794-.222-2.622.648-.62 2.197-.78 4.453-4.04 4.253-1.978 2.074-4.004 4.223-6.515 5.7 1.474 3.383 7.314-3.398 7.04-.54-2.552 3.482 1.314 4.215 3.007 1.535 2.863-3.025 6.408-6.706 10.68-3.658 2.035 1.915 3.217-1.013 4.69-.856.927 2.38 2.095.118 3.148-.555 1.723-.214 1.238 2.153 3.287.695 4.082-2.702 9.104-.432 13.092-3.06 4.244-1.934.596 1.557-.576 2.922-1.864 3.617-.247 8.366-4.292 10.612-1.625 4.31 1.92 9.994-1.696 13.183-.525 2 4.65 1.77 6.103 2.593 2.545.1-.11-5.826 2.416-6.62 3.388 2.096 3.23-3.75 2.53-5.553.328-4.098.56-8.58 2.596-12.292 2.165-4.55 4.17 1.853 1.746 3.655-1.377 4.183-3.38 9.42-.25 13.31.902.202 1.643 2.39 2.81 3.06 1.17.673 2.765-.17 3.056-2.16 1.498-5.99.743-12.434 2.883-18.26 1.512-1.806 3.595-.292 4.532 1.368 3 3.48 5.107 7.833 8.737 10.702 3.305 1.547 6.228 3.886 7.75 7.29-.02 2.625 7.46 3.027 5.224.11-2.144-2.842-.73-5.684 1.442-7.573 1.163.287.82-1.796-.092-.972-1.46-.345-1.554-3.017.476-1.747 3.418 1.104-.267-2.474-1.502-2.583-2.89-1.792-6.21-3.853-7.632-6.967 3.762.04 7.668 2.068 11.512.81 3.082-1.584 6.208.13 7.284 2.848 2.382-.38 1.367-2.77 0-3.565 1.743-.718 2.948-2.21.835-3.524-1.116-1.456 1.496-3.94-1.714-3.836.104-2.453-.86-4.697-3.534-5.544-2.68-2.268-10.538 3.34-10.31-1.77-.792-2.783 3.192-.373 4.306-1.76 1.15-2.933-5.482-2.647-3.294-4.92 1.43-.92 8.137-2.243 2.877-3.227-2.626.72-4.88.186-6.945-1.113-1.883 3.15-7.26-1.71-6.302 3.89-.736 2.108-5.54 7.59-6.842 3.39 1.107-3.29 6.8-4.368 5.035-8.806-.27-2.77-2.568.483-3.65.276-.548-1.724 1.658-3.757 3.195-4.166 3.05 2.346 3.142-2.96 6.043-2.528 2.118-.47-.684-1.38-1.275-1.778.58-1.55 3.832-2.342.644-3.688-2.813-2.087-4.898 2.077-7.218 2.3-2.227-2.515 2.022-3.723 3.194-5.047.063-.988-2.477-.3-1.713-1.158.664-1.187 5.162-1.275 3.056-3.056-3.17-1.09-7.265-.818-10.31.593-1.916.62-2.48 4.956-4.134 4.776-.777-1.93.253-5.738-2.407-6.296zm15 42.362c2.417-.41.05 3.67-1.11 3.61.102-1.465-3.497-1.324-1.264-2.6a7.277 7.277 0 0 1 2.374-1.01z",
    fill: "green"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 80) scale(.0635)",
    fill: "#ffe000"
  }, /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    x: 7560,
    y: 4200
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    x: 6300,
    y: 2205
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    x: 7560,
    y: 840
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    x: 8680,
    y: 1869
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    x: 8064,
    y: 2730
  }))));
};
export default __webpack_public_path__ + "assets/6cae8303a8187b42b854a1bdabf99692.svg";
export { SvgCc as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/cc.svg